import React from 'react'
import Helmet from 'react-helmet'
import './internal.css'
import Tracking, { track_social_click } from '../components/tracking';
const _ = require(`lodash`)
const slugify = require(`slugify`)
import imgEducacion from '../images/educacion.svg';
import imgInmigracion from '../images/inmigracion.svg';
import imgDesastres from '../images/desastres-naturales.svg';
import ArrowRight from '../images/arrow_right.png';
import TeExplicamosLogoWhite from '../images/te-explicamos-white-logo.svg'
import TeExplicamosLogoWhiteMobile from '../images/te-explicamos-white-logo-mobile.svg'
const axios = require(`axios`)

export default class Internal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shortURL: undefined
    };
  }
  sanitize(str) {
    return str === undefined || str === null ? '' : str.replace(/'/gi, "\\\'").normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
  }
  render() {
    const data = this.props.data;
    const location = this.props.location.pathname;
    const filter = data.allSitePage.edges.filter(pag => {
      const currentLoc = typeof window !== 'undefined' ? `${process.env.PREFIX_PATH}${pag.node.path}${location.endsWith('/') ? '/' : ''}` : pag.node.path;
      return location === currentLoc;
    });
    const val = filter.length > 0 ? filter[0].node.context.node : {};
    const trackTitle = val.sheet + ' - ' + this.sanitize(val.baraja) + ' - ' + this.sanitize(val.card);


    var SHEETS = {
      EDUCACION: 'Educación',
      INMIGRACION: 'Inmigración',
      DESASTRES_NATURALES: 'Desastres naturales'
    }
    var CUSTOMNAMESHEETS = {
      [SHEETS.EDUCACION]: 'Educación',
      [SHEETS.DESASTRES_NATURALES]: 'Fenómenos naturales',
      [SHEETS.INMIGRACION]: 'Inmigración'
    }
    var SHEETIMAGE = {
      [SHEETS.EDUCACION]: imgEducacion,
      [SHEETS.DESASTRES_NATURALES]: imgDesastres,
      [SHEETS.INMIGRACION]: imgInmigracion
    }

    var title = val.card;
    var titleEscaped = title.replace(/'/gi, "\\\'");
    var linkString = slugify(_.toLower(title));

    if(this.state.shortURL === undefined)
    {
      axios({
          method: `get`,
          url: `https://syndicator.univision.com/web-api/content?url=${val.url}`,
      }).then(result => {
          if (result.status == 200 && result.data.data.code === undefined) {
              this.setState({
                shortURL: result.data.data.sharing.options.facebook.url
              })
          }
      })
    }

    return (
      <div>
        <Helmet title={val.card}>
          <link rel="canonical" href={val.url} />
          <script type="text/javascript" src="//static.univision.com/external-content/uvn-iframe-resize.js"></script>
          <link href="https://fonts.googleapis.com/css?family=Roboto:400,500,700" rel="stylesheet" />
          <link rel="stylesheet" type="text/css" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"></link>
        </Helmet>
        <div className="contiene_internal">
          <div className="containerInternal">
            <h1 className="titleBaraja"></h1>
            <div className="te-container">
              <div className="header-top">
                <h1 className="title-baraja"></h1>
                <div className="share-links-head">
                  <p>Compartir</p>
                  <ul>
                    <li onClick={() => track_social_click({ social_name: 'facebook', title: 'Te explicamos educación home' })}><a href="https://www.facebook.com/sharer.php?u=https://www.univision.com/noticias/educacion/te-explicamos" target="_blank"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                    <li onClick={() => track_social_click({ social_name: 'twitter', title: 'Te explicamos educación home' })}><a href="https://twitter.com/share?url=https://www.univision.com/noticias/educacion/te-explicamos&text=Aprenda cómo hacer diferentes trámites en Estados Unidos" target="_blank"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li onClick={() => track_social_click({ social_name: 'whatsapp', title: 'Te explicamos educación home' })} className="hide-mobile"><a href="whatsapp://send?text=Te explicamos:Aprenda cómo hacer diferentes trámites en Estados Unidos, Visita: https://www.univision.com/noticias/educacion/te-explicamos"><i className="whatsapp" aria-hidden="true"></i></a></li>
                    <li onClick={() => track_social_click({ social_name: 'mail', title: 'Te explicamos educación home' })}><a href="mailto:?&subject=Te explicamos:&body=Aprenda cómo hacer diferentes trámites en Estados Unidos"><i className="email" aria-hidden="true"></i></a></li>
                  </ul>
                </div>
              </div>
              <div className="feed"></div>
              <section className="cards-container">
                <div className="items" id={linkString}>
                  <div className="card-item">
                    <header>
                      <div className="icon">
                        <img src={SHEETIMAGE[val.sheet]} />
                      </div>
                      <h3>{CUSTOMNAMESHEETS[val.sheet]}</h3>
                    </header>
                    <h2>{title}</h2>
                    <div className="card-content" id={val.idcard} dangerouslySetInnerHTML={{ __html: val.text || '' }}></div>
                    <a className="source" target="_blank" href={val.urlfuente !== undefined ? val.urlfuente : 'javascript:void(0);'}>
                      <div className="source">{(val.fuentes ? 'Fuente: ' + val.fuentes : '')}</div>
                    </a>
                    <div className={`share-links share-links-${val.idcard}`}>
                      <p>Comparte</p>
                      <ul>
                        <li onClick={() => track_social_click({ social_name: 'facebook', title: titleEscaped })}>
                          <a href={`https://www.facebook.com/sharer.php?u=${val.url}`} target="_blank">
                            <i className="fa fa-facebook" aria-hidden="true"></i>
                          </a>
                        </li>
                        <li onClick={() => track_social_click({ social_name: 'twitter', title: titleEscaped })}>
                          <a href={`https://twitter.com/share?url=${this.state.shortURL || val.url}&text=${titleEscaped + ' ' + encodeURIComponent('#TeExplicamos')}&via=uninoticias`} target="_blank">
                            <i className="fa fa-twitter" aria-hidden="true"></i>
                          </a>
                        </li>
                        <li onClick={() => track_social_click({ social_name: 'whatsapp', title: titleEscaped })} className="hide-mobile">
                          <a href={`whatsapp://send?text=Te explicamos: ${titleEscaped}. Visita: ${decodeURIComponent(this.state.shortURL || val.url)}`} data-action="share/whatsapp/share" className="whatsapp"></a>
                        </li>
                        <li onClick={() => track_social_click({ social_name: 'mail', title: titleEscaped })}>
                          <a href={`mailto:?&subject=Te explicamos:${titleEscaped}&body=Visita: ${this.state.shortURL || val.url}`}>
                            <i className="email" aria-hidden="true"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="moreAnswers">
                    <a href={`javascript:gatsby_redirect('${decodeURIComponent(val.url)}');`} ><img src={ArrowRight} />MÁS RESPUESTAS</a>
                    <img src={TeExplicamosLogoWhite} className="onlyDesktop" />
                    <img src={TeExplicamosLogoWhiteMobile} className="onlyMobile" />
                  </div>
                  <div className="disclaimer" dangerouslySetInnerHTML={{ __html: val.disclaimer }}></div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <Tracking trackTitle={trackTitle} currentSheet={val.sheet} />
      </div>
    )
  }
}

export const query = graphql`
  query SiteTitleQueryInternal {
    allSitePage{
      edges {
        node {
          id
          path
          context 
          {
            slug
            node{
              idbaraja
              baraja
              idcard
              card
              text
              url
              sheet
            }
          }
        }
      }
    }
  }`



// WEBPACK FOOTER //
// ./src/layouts/internal.js